import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Input from '../Shared/Input';

// Define simulateApiCall outside component
const simulateApiCall = (delay = 1000) => new Promise((resolve) => {
  setTimeout(resolve, delay);
});

export default function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Properly get hooks
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const MODULE_DEFAULTS = {
    sales: '/sales/dashboard',
    hr: '/hr/dashboard',
    inventory: '/inventory/dashboard',
    pos: '/pos/dashboard',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await simulateApiCall();
      await login(formData);

      // Get module from referrer or fallback
      const module = location.state?.module
                   || Object.keys(MODULE_DEFAULTS).find((m) => location.pathname.includes(m))
                     || 'sales';

      navigate(location.state?.from?.pathname || MODULE_DEFAULTS[module]);
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="demo-auth">
      <h2>DEMO MODE</h2>
      <form onSubmit={handleSubmit}>
        <Input
          type="email"
          placeholder="Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
        />
        <Input
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          required
        />
        <button
          type="submit"
          className="bg-blue-500 text-white py-2 px-4 rounded"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
        {error && <div className="error-message">{error}</div>}
      </form>
    </div>
  );
}
